import { Coffee } from "lucide-react";
import { useTranslation } from "react-i18next";

const MOBILEPAY_URL =
	"https://qr.mobilepay.fi/box/4c52a60e-f12a-41b5-8f77-5153f6e001a3/pay-in";

export function SupportBanner() {
	const { t } = useTranslation("home");

	return (
		<section className="border-t border-border bg-muted py-20">
			<div className="page-wrap grid grid-cols-1 items-center gap-10 lg:grid-cols-[1fr_auto]">
				<div>
					<p className="sec-tag">{t("support.tag")}</p>
					<h2 className="display-title mt-1 text-[clamp(30px,3.2vw,46px)] leading-none tracking-[0.01em] text-foreground">
						{t("support.heading_1")}
						<br />
						<span className="text-primary-accessible">
							{t("support.heading_2_accent")}
						</span>
						{t("support.heading_2_suffix")}
					</h2>
					<p className="mt-4 max-w-[400px] text-sm leading-[1.8] text-muted-foreground">
						{t("support.body")}
					</p>
				</div>

				<div className="flex flex-col items-start gap-2 lg:items-end">
					<a
						href={MOBILEPAY_URL}
						target="_blank"
						rel="noopener noreferrer"
						className="inline-flex items-center gap-2.5 rounded-[var(--radius)] bg-primary px-6 py-3 text-[13px] font-bold uppercase tracking-[0.08em] text-primary-foreground transition-opacity duration-200 hover:opacity-85"
					>
						<Coffee className="h-4 w-4" />
						{t("support.cta")}
					</a>
					<p className="text-[11px] text-muted-foreground">
						{t("support.sub")}
					</p>
				</div>
			</div>
		</section>
	);
}
